import {
    FETCH_SETTINGS_REQUEST,
    FETCH_SETTINGS_SUCCESS,
    FETCH_SETTINGS_FAILURE,
    UPDATE_SETTINGS_REQUEST,
    UPDATE_SETTINGS_SUCCESS,
    UPDATE_SETTINGS_FAILURE,
  } from '../actions/settingsActions';
  
  const initialState = {
    data: {},
    loading: false,
    error: null,
  };
  
  const settingsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SETTINGS_REQUEST:
      case UPDATE_SETTINGS_REQUEST:
        return { ...state, loading: true };
  
      case FETCH_SETTINGS_SUCCESS:
        return { ...state, loading: false, data: action.payload };
  
      case UPDATE_SETTINGS_SUCCESS:
        return { ...state, loading: false, data: action.payload };
  
      case FETCH_SETTINGS_FAILURE:
      case UPDATE_SETTINGS_FAILURE:
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };
  
  export default settingsReducer;
  